"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LedgerSortableField = void 0;
var LedgerSortableField;
(function (LedgerSortableField) {
    LedgerSortableField["LEDGER_TIMESTAMP"] = "ledgerTimestamp";
    LedgerSortableField["DEBIT_AMOUNT"] = "debitAmount";
    LedgerSortableField["CREDIT_AMOUNT"] = "creditAmount";
    LedgerSortableField["REFERENCE"] = "reference";
    LedgerSortableField["RUNNING_BALANCE"] = "runningBalance";
    LedgerSortableField["NAME"] = "name";
})(LedgerSortableField = exports.LedgerSortableField || (exports.LedgerSortableField = {}));
